<form [formGroup]="form" class="extension-grid-container">
  <div class="flex-half">
    <div class="extension-grid-header">Extensions To Include</div>
    <mat-form-field class="search-input-container flex-half">
      <mat-label>Find</mat-label>
      <input type="text" matInput name="search-input" autocomplete="off" formControlName="includeSearchText" />
      <mat-icon matSuffix class="list-search-icon">search</mat-icon>
    </mat-form-field>

    <cdk-virtual-scroll-viewport
      minBufferPx="300"
      maxBufferPx="800"
      itemSize="12"
      class="extension-grid negative-left-margin"
      >
      <div
        (click)="roleOverrideCheckboxes.get(0)?.include ? showPopup(roleOverrideCheckboxes.get(0)) : null"
            [class]="{
               'cursor-pointer': roleOverrideCheckboxes.get(0)?.include
            }"
        >
        <mat-checkbox
          class="margin-to-left"
          [disabled]="formDisabled"
          [checked]="permissions?.allExtensionsIsSelected || roleOverrideCheckboxes.get(0)?.include"
               [class]="{
                  disabled: roleOverrideCheckboxes.get(0)?.include
               }"
          (change)="selectAllCheckedChanged($event)"
          >Select All</mat-checkbox
          >
        </div>
        @for (permission of filteredIncludeGroupPermissions; track permission) {
          <div
            class="privilege-name-container"
            (click)="
               isClickableGroup(permission)
                  ? showPopup(roleOverrideCheckboxes.get(permission.extensionGroup.extensionGroupId))
                  : null
            "
            [class]="{ 'cursor-pointer': isClickableGroup(permission) }"
            >
            <mat-checkbox
              class="margin-to-left"
              [disabled]="this.formDisabled || permissions?.allExtensionsIsSelected"
              [checked]="isCheckedGroup(permission)"
              (change)="$event ? toggleExtensionGroup(permission) : null"
               [class]="{
                  disabled:
                     roleOverrideCheckboxes.get(permission.extensionGroup.extensionGroupId)?.include &&
                     !permissions?.allExtensionsIsSelected
               }"
              color="primary"
              >
              {{ permission.extensionGroup.name }} {{ '- (Group)' }}</mat-checkbox
              >
            </div>
          }
          @for (permission of filteredIncludePermissions; track permission) {
            <div
              class="privilege-name-container"
            (click)="
               isClickable(permission) ? showPopup(roleOverrideCheckboxes.get(permission.extension.extensionId)) : null
            "
              [class]="{ 'cursor-pointer': isClickable(permission) }"
              >
              <mat-checkbox
                class="margin-to-left"
                [disabled]="this.formDisabled || permissions?.allExtensionsIsSelected"
                [checked]="isChecked(permission)"
                (change)="$event ? toggleExtension(permission) : null"
               [class]="{
                  disabled:
                     roleOverrideCheckboxes.get(permission.extension.extensionId)?.include &&
                     !permissions?.allExtensionsIsSelected
               }"
                color="primary"
                >{{ permission.extension.number }} - {{ permission.extension.name
                }}@if (permission.extension.isArchived) {
                <span class="archived-label"> (Archived)</span>
                }</mat-checkbox
                >
              </div>
            }
          </cdk-virtual-scroll-viewport>
        </div>

        <div class="flex-half">
          <div class="extension-grid-header">Extensions To Exclude</div>
          <mat-form-field class="search-input-container flex-half">
            <mat-label>Find</mat-label>
            <input type="text" matInput name="search-input" autocomplete="off" formControlName="excludeSearchText" />
            <mat-icon matSuffix class="list-search-icon">search</mat-icon>
          </mat-form-field>
          <cdk-virtual-scroll-viewport
            minBufferPx="300"
            maxBufferPx="800"
            itemSize="12"
            class="extension-grid negative-left-margin"
            >
            @for (permission of filteredExcludeGroupPermissions; track permission) {
              <div
                class="privilege-name-container"
            (click)="
               isClickableGroup(permission)
                  ? showPopup(roleOverrideCheckboxes.get(permission.extensionGroup.extensionGroupId))
                  : null
            "
                [class]="{ 'cursor-pointer': isClickableGroup(permission) }"
                >
                <mat-checkbox
                  class="margin-to-left"
                  [disabled]="this.formDisabled"
                  [checked]="isCheckedGroup(permission, true)"
                  (change)="$event ? toggleExcludeExtensionGroup(permission) : null"
               [class]="{
                  disabled: roleOverrideCheckboxes.get(permission.extensionGroup.extensionGroupId)?.exclude
               }"
                  color="primary"
                  >
                  {{ permission.extensionGroup.name }} {{ '- (Group)' }}</mat-checkbox
                  >
                </div>
              }
              @for (permission of filteredExcludePermissions; track permission) {
                <div
                  class="privilege-name-container"
            (click)="
               roleOverrideCheckboxes.get(permission.extension.extensionId)?.exclude
                  ? showPopup(roleOverrideCheckboxes.get(permission.extension.extensionId))
                  : null
            "
                  [class]="{ 'cursor-pointer': roleOverrideCheckboxes.get(permission.extension.extensionId)?.exclude }"
                  >
                  <mat-checkbox
                    class="margin-to-left"
                    [disabled]="this.formDisabled"
                    [checked]="isChecked(permission, true)"
                    (change)="$event ? toggleExcludeExtension(permission) : null"
               [class]="{
                  disabled: roleOverrideCheckboxes.get(permission.extension.extensionId)?.exclude
               }"
                    color="primary"
                    >{{ permission.extension.number }} - {{ permission.extension.name
                    }}@if (permission.extension.isArchived) {
                    <span class="archived-label"> (Archived)</span>
                    }</mat-checkbox
                    >
                  </div>
                }
              </cdk-virtual-scroll-viewport>
            </div>
          </form>
